<template>
  <div class="vue-block">
    <VueSlickCarousel v-bind="settings" ref="productSlider" v-if="products.length !== 0" class="custom-product-slide">
      <div class="product-info-box js-product-info-box" v-for="(product, index) in products" :key="product.ID">
        <div v-if="kadraGlobal.userId !== '0'"
          :class="{ 'product-info-box__add-list-wrapper': activeIndex !== index, 'product-info-box__add-list-wrapper product-info-box__add-list-wrapper--active': activeIndex === index }">
          <div class="product-info-box__add-list-close-btn js-product-info-box__add-list-close-btn"
            @click="removeActive(index)"></div>
          <span class="product-info-box__add-list-title">Add to List</span>
          <List :favorites="favorites" :productWishlist="productWishlist" :wishlist="wishlist" :product="product" />
        </div>
        <div class="product-info-box__wrapper">
          <div class="product-info-box__header">
            <div class="product-info-box__header" v-if="kadraGlobal.userId !== '0' && asCustomer.type !== 'salesman'">
              <a class="product-info-box__header-cta-btn js-product-info-box__header-cta-btn" href="javascript:;"
                @click="setActive(index)">Add
                to List</a>
            </div>
          </div>
          <span class="product-info-box__label new" v-if="product.new_badge === '1'">NEW</span>
          <span class="product-info-box__label hot" v-if="product.hot_badge === '1'">HOT</span>
          <div class="product-info-box__img">
            <!-- <img :src="product.thumb" alt="" v-if="product.image">
            <img :src="kadraGlobal.icons + '/src/assets/images/plch.jpg'" alt="" v-else> -->
            <!-- {{product.fws_url}} -->
            <a class="product-info-box__img-link" :href="kadraGlobal.Url + '/product/' + product.slug">
              <img class="product-info-box__img-photo js-product-img"
                :src="product.thumb || kadraGlobal.icons + '/src/assets/images/plch.jpg'" alt="">
            </a>
            <a class="product-info-box__img-zoom" @click="setIndex(index); showPopup();" v-if="product.image">
              <SvgIcon class="search-filter__body-icon" iconName="ico-search-plus" />
            </a>
          </div>
          <div class="product-info-box__title-wrapper">
            <span v-if="product.pa_brand" class="product-info-box__pretitle" v-html="product.pa_brand"></span>
            <span v-else class="product-info-box__pretitle">-</span>
            <a :href="kadraGlobal.Url + '/product/' + product.slug">
              <h3 class="product-info-box__title js-product-info-box__title" v-html="product.title"></h3>
            </a>
          </div>
          <div class="product-info-box__product-desc-wrapper">
            <div class="product-info-box__product-desc">
              <span v-if="product.pa_size && product.pa_color"><span
                  v-html="product.pa_size + ' | ' + product.pa_color"></span></span>
              <span v-else-if="product.pa_size && !product.pa_color"><span v-html="product.pa_size"></span></span>
              <span v-else-if="!product.pa_size && product.pa_color"><span v-html="product.pa_color"></span></span>
              <span v-else><span> - </span></span>
            </div>
            <div class="product-info-box__product-desc js-product-desc-wrap">
              <span class="product-info-box__product-desc-title">UPC:</span>
              <span v-html="product.upc"></span>
            </div>
            <div class="product-info-box__product-desc">
              <span class="product-info-box__product-desc-title">SKU:</span>
              <span v-html="product.sku"></span>
            </div>

            <div class="product-info-box__product-desc product-info-box__product-desc--alt">
              <span class="product-info-box__product-desc-title">CASE PACK:</span>
              <span v-if="product.pack == 1" v-html="product.pack + ' UNIT'"></span>
              <span v-else v-html="product.pack + ' UNITS'"></span>
            </div>
          </div>
          <template>
            <div class="product-info-box__total-wrapper" v-if="kadraGlobal.userId !== '0'">
              <div class="product-info-box__total-price-wrapper">
                  <span v-if="product.price !== product.price_reg" class="product-info-box__total-price product-info-box__total-price--sale" style="color:red;text-decoration:line-through">
                      <span>$</span>{{ product.price_reg }}
                  </span>
                  <span class="product-info-box__total-price">
                      <sup>$</sup>{{ product.price }}
                  </span>
                <span class="product-info-box__total-price-unit">/unit</span>
              </div>
              <div class="product-info-box__total-quantity-wrapper">
                <div class="product-info-box__total-quantity-out" v-if="product.stockStatus !== 'instock' && userType !== 'salesman'">
                  <span class="product-info-box__total-quantity-out-icon"></span>
                  <span class="product-info-box__total-quantity-out-text">Out of Stock</span>
                </div>
                <div class="product-info-box__total-quantity-contaner" v-if="userType != 'salesman'">
                  <span class="product-info-box__total-quantity-toggle product-info-box__total-quantity--minus"
                    @click="removeFromCart(product.ID, index, product.pack)"></span>
                  <input
                  class="product-info-box__total-quantity-toggle-input"
                  v-if="cart[product.ID]"
                  type="text"
                  :value="formattedValue(product.ID)"
                  ref="inputQy"
                  v-on:keyup="onEnter(product.ID, product.inStock, product.pack, index)"
                  min="0"
                  @input="updateValue($event)"
                  maxlength="5"
                  placeholder="0"
                  @focus="handleFocus(product.id)"
                  @blur="handleBlur">

                  <input v-else
                  class="product-info-box__total-quantity-toggle-input"
                  type="text"
                  :value="''"
                  ref="inputQy"
                  v-on:keyup="onEnter(product.ID, product.inStock, product.pack, index)"
                  min="0"
                  @input="updateValue($event)"
                  maxlength="5"
                  placeholder="0"
                  @focus="handleFocus(product.id)"
                  @blur="handleBlur">
                  <span class="product-info-box__total-quantity-toggle product-info-box__total-quantity--plus"
                    v-if="checkCart(product)" @click="addToCart(product.ID, index, product.pack)"></span>
                </div>
                <div class="product-info-box__total-cases-wrap" v-if="userType != 'salesman'">
                  <template v-if="activeIndex2 !== index">
                    <span v-if="cart[product.ID]"
                      class="cart__items-item-quantity-cases cart__items-item-quantity-cases--has-item">Units in
                      cart</span>
                    <span v-else class="product-info-box__total-cases">Units in cart</span>
                  </template>
                </div>
                <div class="salesman-notification-wrap" v-if="userType === 'salesman'">
                  <span class="salesman-notification">Please select a customer.</span>
                </div>
                <span v-if="activeIndex2 === index" class="product-info-box__total-quantity-loader">Processing...</span>
              </div>
            </div>
          </template>
          <div class="product-info-box__more-wrapper product-info-box__more-wrapper--slider"
            @click="toggleReadMore(index)">
            <a class="product-info-box__more" href="javascript:;">Read more</a>
          </div>
        </div><!-- .product-info-box__wrapper -->
        <div
          :class="{ 'product-info-box__hover-content product-info-box__hover-content--padding': showHoverInfo !== index, 'product-info-box__hover-content product-info-box__hover-content--toggle product-info-box__hover-content--padding': showHoverInfo === index }">
          <div v-if="kadraGlobal.userId !== '0'">
            <div v-if="product.acfFields" class="product-info-box__hover-content-header">
              <span v-html="product.acfFields"></span>
            </div>
          </div>
          <a href="javascript:" class="js-popup-login-trigger" @click="openLoginPopup(product.id)" v-else>
            <button class="addToCart loginPrice" data-id="2617">LOGIN TO SEE PRICE</button>
          </a>
          <div class="product-info-box__hover-content-details" v-if="product.description">
            <span class="product-info-box__hover-content-details-title">Additional Product Details</span>
            <div class="product-info-box__hover-content-details-list" v-html="product.description"></div>
          </div>
        </div>
      </div><!-- .product-info-box -->
    </VueSlickCarousel>
    <transition name='fade-in'>
      <div class="product-info-box-popup" v-if="fullImgUrl" @click.self="closePopup()">
        <a href="javascript:;" class="vue-popup__close vue-popup__close--alt" @click.self="closePopup()"></a>
        <div class="product-info-box-popup-wrapper">
          <img :src="fullImgUrl" alt="">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import List from './List.vue';
import VueSlickCarousel from 'vue-slick-carousel';
import SvgIcon from '../../../base/SvgIcon/SvgIcon.vue';

export default {
  props: ['products', 'wishlist', 'favorites', 'productWishlist', 'cart', 'addToCartLoading', 'productId'],
  components: {
    List,
    VueSlickCarousel,
    SvgIcon
  },
  beforeMount() {
    let arr = localStorage.getItem('compare-' + this.kadraGlobal.userId);
    (arr !== null)
      ? arr = JSON.parse(arr)
      : arr = [];
    this.checkedCompare = arr;
    this.$emit('addToCompare', this.checkedCompare);
  },
  data() {
    return {
      kadraGlobal: kadraGlobal,
      asCustomer: usingcustomer.session,
      activeIndex: undefined,
      imageOpen: false,
      userType: window.usingcustomer.session.type,
      settings: {
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        speed: 1000,
        arrows: false,
        responsive: [
          {
            breakpoint: 1349,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 520,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      index: null,
      inputDelay: null,
      activeIndex2: undefined,
      checkedCompare: [],
      showHoverInfo: undefined,
      fullImgUrl: '',
      timeouts: {},
      delayTime: 2000,
    };
  },
  watch: {
    addToCartLoading() {
      if (!this.addToCartLoading) {
        this.activeIndex2 = undefined;
      }

      setTimeout(() => {
        this.equalHeights('product-info-box__product-desc');
        this.equalHeights('product-info-box__product-desc--alt');
        this.equalHeights('product-info-box__title');
        if (window.innerWidth > 1024) {
          this.equalHeightsProductDesc();
        }
        //this.popupScroll();
      }, 1000);
    },
    checkedCompare() {
      this.$emit('addToCompare', this.checkedCompare);
    },
  },
  methods: {
    showPopup() {
      const index = this.index;
      const body = document.querySelector('body');
      this.fullImgUrl = this.products[index].image;
      body.classList.add('scroll-disabled');
    },

    closePopup() {
      this.fullImgUrl = null;
      const body = document.querySelector('body');
      body.classList.remove('scroll-disabled');
    },

    closeImage() {
      this.index = null;
      this.imageOpen = false;
      this.$emit('changeImage', this.imageOpen);
    },
    openImage() {
      this.imageOpen = true;
      this.$emit('changeImage', this.imageOpen);
    },
    updateValue(event) {
      let val = event.target.value;
      const max = event.target.maxLength;

      val = val.replace(/[^0-9]/g, '');

      if (val.length > max) {
        val = val.slice(0, max);
      }

      if (val === '') {
          val = '0';
      }

      event.target.value = val;
    },
    handleFocus(id) {
      this.focusedInput = id;
    },
    handleBlur() {
      this.focusedInput = null;
    },
    removeAllCompare() {
      this.checkedCompare = [];
    },
    toggleReadMore(index) {
      if (window.innerWidth < 1025) {
        if (this.showHoverInfo === index) {
          this.showHoverInfo = undefined;
        } else {
          this.showHoverInfo = index;
        }
      }
    },
    formattedValue(id) {
       return this.cart[id];
    },
    openLoginPopup(ele) {
      const popup = document.getElementsByClassName('js-popup-login-form');
      popup[0].classList.add('active');
      popup[0].setAttribute('data-id', ele);
    },
    setActive(index) {
      (this.activeIndex === index)
        ? this.activeIndex = undefined
        : this.activeIndex = index;
    },
    removeActive() {
      this.activeIndex = undefined;
    },
    addToCart(id, index, pack) {
      this.$store.dispatch('addManyFromCart', {
        'id': id,
      });
      clearTimeout(this.timeouts[id]);
      this.timeouts[id] = setTimeout(async () => {
        if (!this.addToCartLoading) {
          this.activeIndex2 = index;
        }
        console.log('ProductSlider.addToCart');
        await this.$store.dispatch('addManySlider', {
          'id': id,
          'val': this.cart[id],
          'pack': pack
        });

      }, this.delayTime);
    },
    removeFromCart(id, index, pack) {
      if (this.cart[id] !== 0) {
        this.$store.dispatch('minusManyFromCart', {
          'id': id,
        });
      }

      clearTimeout(this.timeouts[id]);
      this.timeouts[id] = setTimeout(async () => {
        if (!this.addToCartLoading) {
          this.activeIndex2 = index;
          await this.$store.dispatch('addManySlider', {
            'id': id,
            'val': this.cart[id],
            'pack': pack
          });
        }
      }, this.delayTime);
    },
    checkCart() {
      return true;
    },
    onEnter(id, qty, pack, index) {
      if (parseInt(event.target.value.charAt(0)) === 0) {
        event.target.value = event.target.value.substring(1);
      }
      let val = event.target.value.trim() === '' ? 0 : parseInt(event.target.value) || 0;
      /* if (val < 0) {
        event.target.value = 0;
        return false;
      } */
     if (isNaN(val) || val <= 0) {
          // prevent negative and literals
          val = 0;
          event.target.value = val;
      }

      /* if (val.includes('.')) {
        event.target.value = 0;
        return false;
      } */

      if (qty === '') {
        clearTimeout(this.inputDelay);
        this.inputDelay = setTimeout(() => {
          this.activeIndex2 = index;
          const obj = {
            'id': id,
            'val': val,
            'pack': pack
          };
          this.$store.dispatch('addMany', obj);
        }, 500);
      } else {
        const check = val * parseInt(pack);
          if (check > parseInt(qty)) {
              // val = qty / pack;
              // val = Math.floor(val);
              event.target.value = val;
          }
        clearTimeout(this.inputDelay);
        this.inputDelay = setTimeout(() => {
          this.activeIndex2 = index;
          const obj = {
            'id': id,
            'val': val,
            'pack': pack
          };
          this.$store.dispatch('addManyAndRefreshCart', obj);
        }, 500);
      }
    },
    showNextSlide() {
      this.$refs.productSlider.next();
    },
    showPrevSlide() {
      this.$refs.productSlider.prev();
    },
    /**
     * @description add equal height to products
     */
    equalHeights: (elName) => {
      setTimeout(() => {
        const products = document.getElementsByClassName(elName);
        let x = 0;

        Array.from(products).forEach((el) => {
          el.style.height = 'auto';
          if (el.offsetHeight > x) {
            x = el.offsetHeight;
          }
        });

        Array.from(products).forEach((el) => {
          el.style.height = `${x}px`;
        });

      }, 100);
    },

    equalHeightsProductDesc: () => {
      setTimeout(() => {
        const products = document.querySelectorAll('.js-products-slider .product-info-box__hover-content');
        const productSlick = document.querySelector('.products-slider__wrapper .slick-list');
        let x = 0;

        Array.from(products).forEach((el) => {
          el.style.height = 'auto';
          if (el.offsetHeight > x) {
            x = el.offsetHeight;
          }
        });
        if (productSlick) {
          productSlick.style.paddingBottom = `${x + 130}px`;
        }
      }, 500);
    },
    setIndex(index) {
      this.index = index;
    },
    /**
     * @description Set Cookie
     * @example Global.functions.setCookie('cookie-name');
     * @param name -> string
     * @param value -> string|array
     * @param time -> expiration date
     * @param path -> path
     */
    setCookie: function (name, value, time = '01 Jan 1970 00:00:00 UTC', path = '/') {
      const ua = window.navigator.userAgent;

      // IE 10 and lower versions
      // const msie = ua.indexOf('MSIE');

      // IE 11
      const trident = ua.indexOf('Trident/');

      if (!(trident > 0)) {
        time = '';
      }

      document.cookie = name + '=' + JSON.stringify(value) + '; expires=' + time + '; path=' + path + ';';
    },

    /**
     * @description Get Cookie
     * @example Global.functions.readCookie('cookie-name');
     * @param name -> string
     */
    readCookie: function (name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
          return JSON.parse(
            c.substring(nameEQ.length, c.length)
          );
        }
      }
      return null;
    },

    /**
     * @description Delete Cookie
     * @example Global.functions.deleteCookie('cookie-name');
     * @param name -> string
     */
    deleteCookie: function (name) {
      document.cookie = name + '=; Path=/; Expires=Thu, 20 Jun 1989 00:00:01 GMT;';
    },
  }
};
</script>

<style lang="scss" scoped>
.product-info-box__hover-content {
  @include mq(1024px) {
    width: 101%;
  }
}

.product-info-box__total-cases-wrap {
  display: flex;
}

.loginPrice {
  margin-top: 11px !important; // sass-lint:disable no-important
  margin-bottom: 11px;
}

.product-info-box__total-quantity-contaner-add {
  margin-top: 0;
  padding: 5px 7px;
  font-size: 12px;
  min-height: 35px;

  @include mq($xl) {
    padding: 5px 3px;
    font-size: 11px;
  }
}

.product-info-box__total-quantity-contaner-added {
  text-align: center;
  font-size: 13px;
  display: block;
  padding: 0 3px;

  @include mq($xl) {
    font-size: 11px;
  }
}

.product-info-box__add-list-wrapper {
  width: 240px;
  transform: translate(-50%, 20%);
  top: 0;

  &::after {
    top: -12px;
    right: 32px;
    left: auto;
    transform: translateX(0);
    border-bottom: 12px solid #fff;
    border-top: none;
  }
}

.products-slider__wrapper .slick-slide {
  padding: 0 10px;
}

.salesman-notification {
  font-size: 14px;
  text-align: center;
  display: inline-block;
  color: $red;
  letter-spacing: -.6px;
  font-family: $font-main;
  font-weight: 400;
}

.product-info-box__total-price--sale {
  font-size: 11px;
  font-weight: 400;
  font-family: $font-main;
  margin-bottom: 2px;
  display: block;
  text-decoration: line-through;
}

.product-info-box__total-quantity-toggle-input {
  &::placeholder {
      color: $white;
  }

  &:focus {
      &::placeholder {
        color: transparent;
    }
  }
}
</style>
